<template>
    <div class="automute-resolver-button">
        <div class="automute-resolver-button-main-component" ref="mainComponent">
            <VrunPlaceholder v-if="automuteResolverService && instance['automute_resolver_button:main_component']"
                :component="instance['automute_resolver_button:main_component']" />
        </div>
        <div class="automute-resolver-button-overlay" :class="{ 'unmute-available': unmutesAvailable }">


            <FHint v-if="unmutesAvailable || instance['automute_resolver_button:force']" icon="fa6-volume-high">
                <template #message>
                    Due to browser restrictions, <br> please click “unmute” to <br>
                    fully enable audio
                </template>
                <template #action>
                    <FButton type="tertiary" @click="automuteResolverService.unmuteAll()">Unmute</FButton>
                </template>
            </FHint>
        </div>
    </div>
</template>
<script>
import { debug } from "/vodalys/.jslibs";
const log = debug('AutomuteResolver:button*')

export default {
    props: {
        instance: Object,
        component: Object
    },
    data() {
        return {
            initializer: Promise,
            automuteResolverService: undefined,
            unmutesAvailable: false,
            removeListener: Function
        }
    },
    created() {
        this.initializer = this.init()
    },
    beforeDestroy() {
        this.initializer.finally(() => {
            log('cleanup autmute resolver')
            this?.removeListener();
        })
    },
    methods: {
        async init() {
            log('automuteResolverService... init')
            while (!this.automuteResolverService) {
                this.automuteResolverService = globalThis?.getAutomuteResolverService(this, this.$refs.mainComponent)
                if (this.automuteResolverService) break;

                await new Promise(resolve => setTimeout(resolve, 100))
                log('waiting for automuteResolverService')
            }

            this.removeListener = this.automuteResolverService.eventEmitter.on('unmutesAvailable', (value) => {
                log('unmutesAvailable', this.automuteResolverService.hasUnmutesAvailable())
                this.unmutesAvailable = this.automuteResolverService.hasUnmutesAvailable()
            })

            log('automuteResolverService.... ready')
            return true
        }
    }
}

</script>
<style lang="scss">
.dark-mode {
    .automute-resolver-button {
        .f-hint {
            background: var(--black) !important;
        }
    }
}

.automute-resolver-button {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;

    &-main-component {
        position: absolute;
        width: 100%;
        height: 100%;

    }

    &-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        justify-content: center;
        align-items: center;


        transition: 125ms ease background-color backdrop-filter;

        &.unmute-available {
            background-color: var(--black-a10);
            // backdrop-filter: blur(5px);
        }



        .f-hint {
            background: white !important;
            gap: 4px;

            border-left: none !important;

            >.f-hint-content {

                gap: 8px;

                >.separator {
                    height: 100%;
                    border-left: 1px solid #DFE5E5
                }


                >.icon {
                    align-self: flex-start;

                    .f-icon {
                        color: var(--statusNotice);
                        font-size: 16px;
                    }
                }

                >.actions {
                    align-self: stretch;
                    display: flex;

                    .f-button {
                        align-self: stretch;
                        padding: 8px;
                    }
                }

            }


        }
    }



}
</style>